var exports = {
  "yS": "FeaturesTableMobile__OqSH_0",
  "KA": "FeaturesTableMobile__title__8wsFWU",
  "$G": "FeaturesTableMobile__featureItem__xUDSyv",
  "Co": "FeaturesTableMobile__featureItemTitleBlock__38jpXV",
  "$C": "FeaturesTableMobile__featureItemTitleBlock-title__1ZJ6og",
  "AM": "FeaturesTableMobile__featureItemTitleBlock-chevron__ANBzTF",
  "b4": "FeaturesTableMobile__featureItemTitleBlock--expanded__jbit0T",
  "JL": "FeaturesTableMobile__featureItemTitleBlock-description__mqxXMH",
  "NT": "FeaturesTableMobile__featureItemTier__M8KtRC",
  "sV": "FeaturesTableMobile__featureItemTier-label__zjBEB6",
  "rB": "FeaturesTableMobile__featureItemTier-availability__WAS-MB",
  "Sd": "FeaturesTableMobile__featureItemTier-availability--green__VSE1pt",
  "iM": "FeaturesTableMobile__featureItemTier-availability--grey__inFve4",
};

module.exports = exports;
